import { defineStore } from 'pinia'

const useGloubStore = defineStore('gloubStore', {
    state: () => ({
        point: 0,
        total_used_points:0,
    }),
  persist: true,
})

export default useGloubStore